import { memo, useEffect, useRef } from "react";
import VolumeMeter from "../Components/VolumeMeter";
import $ from "jquery";
import "select2/dist/css/select2.min.css";
import "select2";
import ToggleSwitch from "../Sub_components/ToggleSwitch";
import { useLiveStreamAppContext } from "../ContextStore/Store";
import ClassAppointmentExitPopup from "../PopupModal/EndCallModal";
import { useLocation } from "react-router-dom";
import PermissionsFetch from "../GeneralFunctions/PermissionsFetch";

function MediaDeviceSelector({ isClassScreen, onClose, panelReff }) {
  const {
    role,
    filteredMain,
    setMicrophone,
    setSpeaker,
    setCamera,
    camera,
    cameras,
    microphones,
    speakers,
    permissionError,
    setPermissionError,
    microphone,
    speaker,
    eventType,
    filteredPreviewClass,
    filteredPreviewAppointment,
    toggleGearMobile,
    isMobile,
    isAndroidTablet,
    toggleStates,
    setToggleStates,
    isMic,
    microphonePermission,
    cameraPermission,
    setIsCam,
    setIsMic,
  } = useLiveStreamAppContext();

  const { checkPermissions } = PermissionsFetch();

  const speakerRef = useRef(null);
  const microphoneRef = useRef(null);
  const cameraRef = useRef(null);

  const location = useLocation();

  // Browsers without HTMLMediaElement.setSinkId (Android Chrome, Samsung Internet,
  // iOS Safari, WebViews) cannot switch audio output - the OS controls routing,
  // so the speaker dropdown would render empty or silently do nothing
  const isSpeakerSelectionSupported =
    typeof HTMLMediaElement !== "undefined" &&
    "setSinkId" in HTMLMediaElement.prototype;

  // To segregate unique values from the array
  const uniqueSpeakers = Array.from(
    new Set(speakers.map((device) => device.deviceId))
  )
    .map((id) => speakers.find((device) => device.deviceId === id));
  //.filter((device) => !/teams/i.test(device.label));

  const uniqueMicrophones = Array.from(
    new Set(microphones.map((device) => device.deviceId))
  ).map((id) => microphones.find((device) => device.deviceId === id));
  //.filter((device) => !/teams/i.test(device.label));

  const uniqueCameras = Array.from(
    new Set(cameras.map((device) => device.deviceId))
  ).map((id) => cameras.find((device) => device.deviceId === id));

  //useEffect for Handling Speaker,Mic & Camera Values
  useEffect(() => {
    if (speakerRef.current) {
      $(speakerRef.current)
        .select2({ placeholder: "Select a Speaker", allowClear: true })
        .on("select2:select", function (e) {
          const selectedDeviceId = e.params.data.id;
          setSpeaker(selectedDeviceId);
          sessionStorage.setItem("speaker", selectedDeviceId)
        })
        .on("select2:open", function () {
          $("span.select2-container.select2-container--open").addClass(
            "livestream-dropdownList"
          );
        });
    }

    if (microphoneRef.current) {
      $(microphoneRef.current)
        .select2({ placeholder: "Select a Microphone", allowClear: true })
        .on("select2:select", function (e) {
          const selectedDeviceId = e.params.data.id;
          setMicrophone(selectedDeviceId);
          sessionStorage.setItem("microphone", selectedDeviceId)
        })
        .on("select2:open", function () {
          $("span.select2-container.select2-container--open").addClass(
            "livestream-dropdownList"
          );
        });
    }

    if (cameraRef.current) {
      $(cameraRef.current)
        .select2({ placeholder: "Select a Camera", allowClear: true })
        .on("select2:select", function (e) {
          const selectedDeviceId = e.params.data.id;
          setCamera(selectedDeviceId);
          sessionStorage.setItem("camera", selectedDeviceId)
        })
        .on("select2:open", function () {
          $("span.select2-container.select2-container--open").addClass(
            "livestream-dropdownList"
          );
        });
    }
  }, [speakers, microphones, cameras]);

  // select2 does not follow React's `value` - redraw it when the device is changed elsewhere
  // (e.g. from the Troubleshooting popup). "change.select2" only refreshes the UI, so the
  // select2:select handlers above do not fire again
  useEffect(() => {
    [
      [speakerRef, speaker],
      [microphoneRef, microphone],
      [cameraRef, camera],
    ].forEach(([ref, value]) => {
      if (ref.current && value && $(ref.current).val() !== value) {
        $(ref.current).val(value).trigger("change.select2");
      }
    });
  }, [speaker, microphone, camera]);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (
      !(navigator.userAgent.indexOf("com.vagaro.customerios") > -1) ||
      !(
        /iPhone|iPad|Macintosh/i.test(userAgent) &&
        (navigator.maxTouchPoints || 0) > 1
      )
    ) {
      checkPermissions();
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      // Get DOM elements once at the start
      const removeBackgroundNoiseDiv = document.getElementById("removeBackgroundNoisediv");
      const shareDeviceAudioDiv = document.getElementById("shareDeviceAudiodiv");

      // Handle shareDeviceAudio toggle
      if (microphonePermission !== "granted" && toggleStates.shareDeviceAudio) {
        setToggleStates(prev => ({
          ...prev,
          removeBackgroundNoise: false
        }));
        removeBackgroundNoiseDiv?.classList.add("divDisabled");
      } else if (isMic && microphonePermission === "granted") {
        removeBackgroundNoiseDiv?.classList.remove("divDisabled");
      }

      // Handle removeBackgroundNoise toggle
      if (microphonePermission !== "granted" && toggleStates.removeBackgroundNoise) {
        setToggleStates(prev => ({
          ...prev,
          shareDeviceAudio: false
        }));
        shareDeviceAudioDiv?.classList.add("divDisabled");
      } 
      //else if (isMic) {
        // shareDeviceAudioDiv?.classList.remove("divDisabled");
      //}
    }, 1000); // 800ms delay

    return () => clearTimeout(timer); // Cleanup the timer on unmount
  }, [toggleStates.removeBackgroundNoise, toggleStates.shareDeviceAudio, isMic, microphonePermission]);

  useEffect(() => {
    const el = document.getElementById('shareDeviceAudiodiv');
    if (el) {
      el.classList.add('shreDeviceAudioCheckbox');
    }
  }, []);

  
    useEffect(() => {
      let removeBackgroundNoise = document.getElementById(
        "removeBackgroundNoisediv"
      );
      let micDropdown = document.getElementById("micDropdown");
      
        removeBackgroundNoise?.classList.add("divDisabled");
      let shareDeviceAudiodiv = document.getElementById("shareDeviceAudiodiv");
      if (microphonePermission === "granted") {
        // setIsMicrophoneEnabled(true);
        //const element = document.querySelector("#mic_icon");
        
        //setIsMic(false);
        micDropdown?.classList.contains("divDisabled") &&
        micDropdown?.classList.remove("divDisabled");
        shareDeviceAudiodiv?.classList.contains("divDisabled") &&
        shareDeviceAudiodiv?.classList.remove("divDisabled");
        //if (!element) {
          //console.error("Element not found.");
          //return;
        //}
        //element.classList.add("va-microphone-slash");
      }else if (microphonePermission !== "granted") {
        setToggleStates((prev) => ({
          ...prev,
          removeBackgroundNoise: false,
          shareDeviceAudio: false,
        }));
        !removeBackgroundNoise?.classList.contains("divDisabled") &&
          removeBackgroundNoise?.classList.add("divDisabled");
        !shareDeviceAudiodiv?.classList.contains("divDisabled") &&
          shareDeviceAudiodiv?.classList.add("divDisabled");
        !micDropdown?.classList.contains("divDisabled") &&
          micDropdown?.classList.add("divDisabled");
      }
    }, [microphonePermission,toggleStates.shareDeviceAudio]);
  
    useEffect(() => {
      let blurBackground = document.getElementById("blurBackgrounddiv");
      let mirrorMyVideo = document.getElementById("mirrorMyVideodiv");
      let FitToFramediv = document.getElementById("FitToFramediv");
      let camDropdown = document.getElementById("camDropdown");
      if (cameraPermission === "granted") {
        // setIsCameraEnabled(true);
        
              camDropdown?.classList.contains("divDisabled") &&
                camDropdown?.classList.remove("divDisabled");
              // blurBackground?.classList.contains("divDisabled") &&
              //   blurBackground?.classList.remove("divDisabled");
              FitToFramediv?.classList.contains("divDisabled") &&
                FitToFramediv?.classList.remove("divDisabled");
        const element = document.querySelector("#cam_icon");
        if (!element) {
          console.warn("Element not found.");
          return;
        }
  
        element.classList.add("va-video-slash");
        // setIsCam(false);
      } else if (cameraPermission !== "granted") {
        setToggleStates((prev) => ({
          ...prev,
          blurBackground: false,
          mirrorMyVideo: false,
        }));
        !blurBackground?.classList.contains("divDisabled") &&
          blurBackground?.classList.add("divDisabled");
        !mirrorMyVideo?.classList.contains("divDisabled") &&
          mirrorMyVideo?.classList.add("divDisabled");
        !FitToFramediv?.classList.contains("divDisabled") &&
          FitToFramediv?.classList.add("divDisabled");
        !camDropdown?.classList.contains("divDisabled") &&
          camDropdown?.classList.add("divDisabled");
      }
  
      // let mirrorMyVideo = document.getElementById("mirrorMyVideodiv");
      // !mirrorMyVideo?.classList.contains("divDisabled") &&
      //   mirrorMyVideo?.classList.add("divDisabled");
    }, [cameraPermission]);

  const newSettings = [
    {
      label: "Blur Background",
      key: 1,
      name: "blurBackground",
    },
    {
      label: "Remove Background Noise",
      key: 2,
      name: "removeBackgroundNoise",
      browserSupportText: "Only avaliable on Chrome and Microsoft Edge browsers.",
    },
    {
      label: "Share Device Audio",
      key: 3,
      name: "shareDeviceAudio",
      ifInfo: true,
      ifInfoMessage: "Attendees cannot share audio in a class.",
      browserSupportText: "Only avaliable on Chrome and Microsoft Edge browsers.",
    },
    {
      label: "Mirror My Video",
      key: 4,
      name: "mirrorMyVideo",
    }
  ];

  return (
    <>
      <div className="panel-title-for-mob">
        <div
          className="backIcon"
          onClick={() => {
            if (typeof onClose === "function") {
              onClose();
            }
            toggleGearMobile();
          }}
          style={{ cursor: "pointer" }}
        >
          <i className="icon font-awesome-normal-pro va-back-arrow"></i>
        </div>
        <div className="back-page-title">
          <span>{isMobile ? "Settings" : "Device Settings"}</span>
        </div>
      </div>
      <div ref={panelReff} className="media-comp-div">
        {/* {permissionError && (
          <ClassAppointmentExitPopup
            show={permissionError}
            onHide={() => setPermissionError(false)}
            handleEndCall={() => {
              if (navigator.userAgent.includes("Macintosh") && /^((?!chrome|android).)*safari/i.test(navigator.userAgent)){
                window.close();
              } else {
                setPermissionError(false);
              }
            }}
            message={
              //"Require Camera and Microphone access from browser settings."
              "Open System Settings > Privacy & Security to grant access."
            
            }
            buttontext={"Ok"}
            devicePermissionModal={true}
            headtext={"Allow Vagaro to Access Microphone"}
          />
        )} */}
        {location.pathname === "/livestream/meeting" && (
          <div className="section-title setting-text deviceSettings">Device Settings</div>
        )}
        <div className="setting-section-audio">
          {isSpeakerSelectionSupported && uniqueSpeakers.length > 0 && (
            <div className="select2ControlWrap mb8" id="speaker">
              <label htmlFor="speaker-select" className="l-label-text">
                Speaker{!isMobile && ":"}
              </label>

              <select
                ref={speakerRef}
                id="speaker-select"
                style={{ width: "100%" }}
                className="livestream-dropdownList custom-select"
                value={speaker}
                defaultValue={speaker}
              >
                {uniqueSpeakers.map((speaker, index) => (
                  <option key={index} value={speaker.deviceId}>
                    {speaker.label || "Unnamed Speaker"}
                  </option>
                ))}
              </select>

            </div>
          )}
          <div className={`select2ControlWrap mb12`} id="micDropdown">
            <label htmlFor="microphone-select" className="l-label-text">
              Microphone{!isMobile && ":"}
            </label>

            <select
              ref={microphoneRef}
              id="microphone-select"
              style={{ width: "100%" }}
              className="custom-select"
              defaultValue={microphone}
              value={microphone}
            >
              {uniqueMicrophones.map((microphone, index) => (
                <option key={index} value={microphone.deviceId}>
                  {microphone.label || "Unnamed Microphone"}
                </option>
              ))}
            </select>

          </div>
          <div>
            <VolumeMeter />
          </div>
          <div className={`select2ControlWrap`} id="camDropdown">
            <label htmlFor="camera-select" className="l-label-text">
              Camera{!isMobile && ":"}
            </label>

            <select
              ref={cameraRef}
              id="camera-select"
              style={{ width: "100%" }}
              className="custom-select"
              defaultValue={camera}
              value={camera}
              onChange={() => { }}
            >
              {uniqueCameras.map((camera, index) => (
                <option key={index} value={camera.deviceId}>
                  {camera.label || "Unnamed Camera"}
                </option>
              ))}
            </select>
          </div>

          <div className="section-title setting-text margintop15">
            Your Settings{!isMobile && ":"}
          </div>
          <div className="section-checkboxes input-view-on-mobile yourSettingBlock">
            {/* <MobileViewDetail /> */}
            <div className="public-screen-name">
              <div className="setting-popup-checkbox">
                {newSettings.map((item) => (
                  !((isMobile || isAndroidTablet) && item.key != 4) && <ToggleSwitch
                    label={item.label}
                    key={item.key}
                    ifInfo={role === "Presenter" ? undefined : item.ifInfo}
                    ifInfoMessage={role === "Presenter" ? undefined : item.ifInfoMessage}
                    message={item.message}
                    name={item.name}
                    browserSupportText={item.browserSupportText}
                  />
                ))}

                {(role === "Attendee" || (role === "Presenter" && isMobile)) &&
                  filteredMain
                    .filter(
                      (item) =>
                        item.user === "both" &&
                        item.isPreviewAttendeeApp &&
                        item.isPreviewAttendeeApp === true
                    )
                    .map((item, index) => {
                      return (

                        <ToggleSwitch
                          label={item.lable}
                          key={index}
                          ifInfoMessage={item.ifInfoMessage}
                          ifInfo={item.ifInfo}
                          message={item.message}
                          name={item.name}
                        />
                      )
                    })}
              </div>
            </div>
          </div>

          {!isClassScreen && eventType !== 1 && (
            <div className="section-checkboxes input-view-on-mobile">
              <div className="public-screen-name">
                {role === "Presenter" && (
                  <div className="section-title setting-text margintop15">
                    Attendee Settings{!isMobile && ":"}
                  </div>
                )}
                <div className="setting-popup-checkbox ">
                  {role === "Presenter" &&
                    (eventType === 2
                      ? filteredPreviewClass.map((item, index) => {
                        return (
                          item.name === "FitToFrame" && isMobile ? null : <ToggleSwitch
                            label={item.lable}
                            key={index}
                            ifInfo={item.ifInfo}
                            ifInfoMessage={item.ifInfoMessage}
                            message={item.message}
                            name={item.name}
                          />
                        );
                      })
                      : filteredPreviewAppointment.map((item, index) => {
                        return (
                          <ToggleSwitch
                            label={item.lable}
                            key={index}
                            ifInfoMessage={item.ifInfoMessage}
                            ifInfo={item.ifInfo}
                            message={item.message}
                            name={item.name}
                          />
                        );
                      }))}
                </div>
              </div>
            </div>
          )}

          {isClassScreen && (
            <>
              {(!(eventType === 2 && role === "Attendee") ||
                !(role === "Attendee" && eventType === 1)) &&
                role === "Presenter" ? (
                <div className="section-title setting-text margintop15 removeForMobile">
                  Attendee Settings{!isMobile && ":"}
                </div>
              ) : null}
              {location.pathname === "/livestream/meeting" && (
                <div className="video-overlay-black"></div>
              )}
              <div className="section-checkboxes input-view-on-mobile">
                <div className="public-screen-name">
                  <div className="setting-popup-checkbox ">
                    {role === "Presenter" &&
                      location.pathname !== "/livestream/start"
                      ? filteredMain
                        .map((item, index) => {
                          if (isMobile && item.isMobileGear) return null;
                          return (
                            <ToggleSwitch
                              label={item.lable}
                              key={index}
                              ifInfoMessage={item.ifInfoMessage}
                              ifInfo={item.ifInfo}
                              message={item.message}
                              name={item.name}
                            />
                          );
                        })
                      : filteredMain
                        .filter((item) => item.user === "both")
                        .map((item, index) => {
                          if (
                            (isMobile && item.isMobileGear) ||
                            role === "Attendee"
                          )
                            return null;
                          return (
                            <ToggleSwitch
                              label={item.lable}
                              key={index}
                              ifInfoMessage={item.ifInfoMessage}
                              ifInfo={item.ifInfo}
                              message={item.message}
                              name={item.name}
                            />
                          );
                        })}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default memo(MediaDeviceSelector);